/**
 * BandeauDemo.tsx — S232, M1 : bandeau « Démo — données fictives », visible sur toutes les vues de la V3 quand le tenant actif est le
 * compte démo (estTenantDemo, demo-tenant.ts), jamais ailleurs. Classes copiées du motif « BANDEAU BOTTOM » de memory/design-system.md
 * (lignes 434-440), plus shrink-0 pour la colonne du shell. Monté par FrameMasterAmorcer.tsx (AmorcerLayout).
 * Le tenant actif vient de GET /api/v1/auth/me (tenant_id et memberships[].tenant_slug), lu avec le jeton du navigateur comme les hooks
 * de la V3 (useCprj.ts, useCahierV3.ts) : aucun import de l'interface précédente (garde-fou V2IMPORTS.GUARD.1).
 */

import { useEffect, useState } from "react";
import { Info } from "lucide-react";
import { estTenantDemo, membershipActif, TEXTE_BANDEAU_DEMO } from "./demo-tenant";

const _KEY = (import.meta as unknown as { env?: Record<string, string | undefined> }).env?.VITE_API_KEY || "missing-key";

export function BandeauDemo() {
  const [demo, setDemo] = useState(false);
  useEffect(() => {
    let vivant = true;
    let jwt: string | null = null;
    try { jwt = localStorage.getItem("ghostx-jwt"); } catch { jwt = null; }
    if (!jwt) return;
    fetch("/api/v1/auth/me", { headers: { "X-API-Key": _KEY, Authorization: `Bearer ${jwt}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((me) => { if (vivant) setDemo(estTenantDemo(membershipActif(me))); })
      .catch(() => { /* sans réponse : pas de bandeau */ });
    return () => { vivant = false; };
  }, []);
  if (!demo) return null;
  return (
    <div data-testid="bandeau-demo" role="status" className="shrink-0 bg-blue-50/50 border border-blue-100 rounded-lg px-3 py-2 flex items-center gap-2">
      <Info className="h-3.5 w-3.5 text-blue-500 shrink-0" />
      <span className="text-[9px] text-blue-700">{TEXTE_BANDEAU_DEMO}</span>
    </div>
  );
}
